import ReportsPage from './ReportsPage';

export type TTabname = 'users' | 'verifiers';

export default ReportsPage;
